import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class MovimientoStockService {
  constructor(private gqlclient: GraphQLClient) { }

  obtenerReporteMovimientoStock(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerReporteMovimientoStock(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    rut_emisor
                    sucursal_codigo
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    bodega_codigo
                    bodega_nombre
                    rubro_codigo
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    fecha_movimiento
                    documento
                    recorrido_codigo
                    tipo_movimiento_codigo
                    tipo_movimiento_nombre
                    ingresosCantidad
                    ingresosFraccion
                    salidasCantidad
                    salidasFraccion
                    saldoCantidad
                    saldoFraccion
                    esFilaSaldoInicial
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerReporteMovimientoStock;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteMovimientoStockExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType) {
            movimiento_stock {
              obtenerReporteMovimientoStock(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerReporteMovimientoStock;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerInventarioGeneralResumen(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerInventarioGeneralResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    bodega_codigo
                    bodega_nombre
                    producto_codigo
                    sku
                    producto_descripcion
                    rubro_codigo
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    saldo
                    costo_total
                    producto_activo
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerInventarioGeneralResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerInventarioGeneralResumenExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType) {
            movimiento_stock {
              obtenerInventarioGeneralResumen(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerInventarioGeneralResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerInventarioGeneralDetalle(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerInventarioGeneralDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    bodega_codigo
                    bodega_nombre
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    rubro_codigo
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    saldo
                    caja
                    fraccion
                    costo_total
                    producto_activo
                    costo_formato_principal
                    preciosXUnidades {
                      lista_precio_codigo
                      precio_neto
                    }
                    listaStockxUnidadesxBodega {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                      bodega_codigo
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerInventarioGeneralDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerInventarioGeneralDetalleExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType) {
            movimiento_stock {
              obtenerInventarioGeneralDetalle(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerInventarioGeneralDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSaldoXSkuXMes(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerSaldoXSkuXMes(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    fecha_movimiento
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    bodega_codigo
                    bodega_nombre
                    saldo_inicial
                    ingresos
                    salidas
                    saldo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerSaldoXSkuXMes;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSaldoXSkuXMesExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType) {
            movimiento_stock {
              obtenerSaldoXSkuXMes(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerSaldoXSkuXMes;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerStockValorizadoResumen(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerStockValorizadoResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    bodega_codigo
                    bodega_nombre
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    rubro_codigo
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    saldo
                    precio_unidad
                    precio_ref
                    costo_total
                    producto_activo
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerStockValorizadoResumen.mensajes,
          respuesta: response.data.movimiento_stock.obtenerStockValorizadoResumen.respuesta,
        });
      }
    );
  }

  obtenerStockValorizadoDetalle(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerStockValorizadoDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    bodega_codigo
                    bodega_nombre
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    rubro_codigo
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    saldo
                    precio_unidad
                    precio_ref
                    costo_total
                    costo_formato_principal
                    producto_activo
                    listaStockxUnidadesxBodega {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                      bodega_codigo
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerStockValorizadoDetalle.mensajes,
          respuesta: response.data.movimiento_stock.obtenerStockValorizadoDetalle.respuesta,
        });
      }
    );
  }

  obtenerStockValorizadoDetalleExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType) {
            movimiento_stock {
              obtenerStockValorizadoDetalle(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerStockValorizadoDetalle.mensajes,
          respuesta: response.data.movimiento_stock.obtenerStockValorizadoDetalle.respuesta,
        });
      }
    );
  }

  obtenerMovimientoESSKU(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        sku: string;
        listaBodega: [];
        mes: number;
        anno: number;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerMovimientoESSKU(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    fecha_movimiento
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    bodega_codigo
                    bodega_nombre
                    tipo_movimiento_codigo
                    tipo_movimiento_nombre
                    documento
                    ingresosCantidad
                    ingresosFraccion
                    salidasCantidad
                    salidasFraccion
                    saldoCantidad
                    saldoFraccion
                    esFilaSaldoInicial
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerMovimientoESSKU.mensajes,
          respuesta: response.data.movimiento_stock.obtenerMovimientoESSKU.respuesta,
        });
      }
    );
  }

  obtenerMovimientoESSKUExcel(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        sku: string;
        listaBodega: [];
        mes: number;
        anno: number;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerMovimientoESSKU(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerMovimientoESSKU.mensajes,
          respuesta: response.data.movimiento_stock.obtenerMovimientoESSKU.respuesta,
        });
      }
    );
  }

  obtenerStockUnProducto(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        fecha_movimiento: Date | string;
        sku: string;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerStockUnProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    bodega_codigo
                    bodega_nombre
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    rubro_codigo
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    saldo
                    producto_activo
                     listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerStockUnProducto.mensajes,
          respuesta: response.data.movimiento_stock.obtenerStockUnProducto.respuesta,
        });
      }
    );
  }

  obtenerStockUnProductoExcel(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        fecha_movimiento: Date;
        sku: string;
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_stock {
              obtenerStockUnProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.movimiento_stock.obtenerStockUnProducto.mensajes,
          respuesta: response.data.movimiento_stock.obtenerStockUnProducto.respuesta,
        });
      }
    );
  }

  guardarReservaCombo(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: movimiento_stockInputType, $operacion: Int) {
            movimiento_stock {
              guardarReservaCombo(entidad: $entidad, operacion: $operacion) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  rut_emisor
                  sucursal_codigo
                  bodega_codigo
                  producto_codigo
                  formato_codigo
                  cantidad
                  listaProductosCombo {
                    producto_codigo
                    sku
                    producto_descripcion
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.guardarReservaCombo;
        callback({ mensajes, respuesta });
      }
    );
  }

  validarStockYAgregar(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        bodega_codigo: number;
        producto_codigo: number;
        sku: number;
        producto_descripcion: string;
        formato_codigo: string;
        formato_nombre: string;
        cantidad: number;
      };
      operacion: number;
      lista: any[];
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_stockInputType, $lista: [movimiento_stockInputType], $operacion: Int) {
            movimiento_stock {
              agregarMovimientoDetalle(entidad: $entidad, lista: $lista, operacion: $operacion) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  es_venta
                  es_compra
                  rut_emisor
                  rut_empresa
                  folio
                  tipo_dte_codigo
                  fecha_movimiento
                  producto_codigo
                  sku
                  producto_descripcion
                  formato_codigo
                  formato_nombre
                  referencia
                  operacion
                  cantidad
                  dia_movimiento
                  mes_movimiento
                  tipo_movimiento_codigo
                  bodega_sucursal_codigo_ingreso
                  bodega_codigo_ingreso
                  bodega_sucursal_codigo_salida
                  bodega_codigo_salida
                  periodo_anno_mes
                  sucursal_codigo
                  precio_costo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_stock.agregarMovimientoDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }
}
